<div class="round-step" [ngClass]="getStepClass()">
    <ng-container *ngIf="status.current; else notCurrent">
        <ng-container *ngIf="status.id !== 4; else showId">
            <img alt="step" [src]="status.id < 5 ? '/assets/current-step.svg' : '/assets/close.svg'" />
        </ng-container>
        <ng-template #showId>
            <span>{{ status.id }}</span>
        </ng-template>
    </ng-container>
    <ng-template #notCurrent>
        <span>{{ status.id }}</span>
    </ng-template>
</div>
